import { PrinterOutlined } from '@ant-design/icons';
import { AButton } from '../Button';

interface ButtonPrintProps {
  show: boolean;
  onClick:
    | (React.MouseEventHandler<HTMLAnchorElement> &
        React.MouseEventHandler<HTMLButtonElement>)
    | undefined;
}

export const AButtonPrint: React.FC<ButtonPrintProps> = ({ show, onClick }) => {
  if (!show) return <></>;
  return (
    <AButton
      style={{ marginTop: 20 }}
      type="dashed"
      icon={<PrinterOutlined />}
      onClick={onClick}
    >
      Imprimir
    </AButton>
  );
};
